export default __webpack_public_path__ + "static/media/3.5c41aa5b.jpg";